import { Alert } from '@montugroup/design-system';
import { styled } from '@mui/material';
export const StyledAlert = styled(Alert)(({ theme, isTopBanner, bgColor }) => ({
    width: '100%',
    paddingInline: theme.spacing(4),
    backgroundColor: bgColor,
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'column',
    ...(isTopBanner && {
        [theme.breakpoints.up('sm')]: {
            paddingInline: theme.spacing(14),
            flexDirection: 'row',
        },
    }),
    '& .MuiAlert-icon': {
        alignSelf: 'flex-start',
    },
    '& .MuiAlert-message': {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        flex: 1,
    },
    '& .MuiAlert-action': {
        alignSelf: 'center',
        padding: '0px',
        margin: '0px',
    },
}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ2xhc3NpY0NhcmQuc3R5bGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvYnJhemUvY2FyZHMvQ2xhc3NpY0NhcmQuc3R5bGVzLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsS0FBSyxFQUFFLE1BQU0sMkJBQTJCLENBQUM7QUFDbEQsT0FBTyxFQUFFLE1BQU0sRUFBRSxNQUFNLGVBQWUsQ0FBQztBQUV2QyxNQUFNLENBQUMsTUFBTSxXQUFXLEdBQUcsTUFBTSxDQUFDLEtBQUssQ0FBQyxDQUN0QyxDQUFDLEVBQUUsS0FBSyxFQUFFLFdBQVcsRUFBRSxPQUFPLEVBQUUsRUFBRSxFQUFFLENBQUMsQ0FBQztJQUNwQyxLQUFLLEVBQUUsTUFBTTtJQUNiLGFBQWEsRUFBRSxLQUFLLENBQUMsT0FBTyxDQUFDLENBQUMsQ0FBQztJQUMvQixlQUFlLEVBQUUsT0FBTztJQUN4QixPQUFPLEVBQUUsTUFBTTtJQUNmLFVBQVUsRUFBRSxZQUFZO0lBQ3hCLGFBQWEsRUFBRSxRQUFRO0lBQ3ZCLEdBQUcsQ0FBQyxXQUFXLElBQUk7UUFDakIsQ0FBQyxLQUFLLENBQUMsV0FBVyxDQUFDLEVBQUUsQ0FBQyxJQUFJLENBQUMsQ0FBQyxFQUFFO1lBQzVCLGFBQWEsRUFBRSxLQUFLLENBQUMsT0FBTyxDQUFDLEVBQUUsQ0FBQztZQUNoQyxhQUFhLEVBQUUsS0FBSztTQUNyQjtLQUNGLENBQUM7SUFDRixrQkFBa0IsRUFBRTtRQUNsQixTQUFTLEVBQUUsWUFBWTtLQUN4QjtJQUNELHFCQUFxQixFQUFFO1FBQ3JCLE9BQU8sRUFBRSxNQUFNO1FBQ2YsYUFBYSxFQUFFLFFBQVE7UUFDdkIsVUFBVSxFQUFFLFlBQVk7UUFDeEIsSUFBSSxFQUFFLENBQUM7S0FDUjtJQUNELG9CQUFvQixFQUFFO1FBQ3BCLFNBQVMsRUFBRSxRQUFRO1FBQ25CLE9BQU8sRUFBRSxLQUFLO1FBQ2QsTUFBTSxFQUFFLEtBQUs7S0FDZDtDQUNGLENBQUMsQ0FDSCxDQUFDIn0=